/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable } from '@rxdi/core';
import { TemplateResult } from '@rxdi/lit-html';
import { ModalService } from '@rxdi/ui-kit/modal';
import { MODAL_DIALOG_OPTIONS } from '@rxdi/ui-kit/modal/interface';
import { DialogData } from '@rxdi/ui-kit/modals/main/interface';
import { take } from 'rxjs/operators';

import { options } from './modal.options';

@Injectable()
export class ModalProvider {
  @Inject(ModalService)
  private modalService: ModalService;

  open(template: TemplateResult, dialogOptions: MODAL_DIALOG_OPTIONS = options) {
    return this.modalService.open(template, dialogOptions);
  }

  openComponent<T>(component: any, params = null, dialogOptions: MODAL_DIALOG_OPTIONS = options) {
    return this.modalService.openComponent<T>(component, params, dialogOptions);
  }

  openCustomModal(data: DialogData, dialogOptions: MODAL_DIALOG_OPTIONS) {
    return this.modalService.openCustomModal(data, dialogOptions);
  }

  openConfirmDialog(data: DialogData) {
    return this.modalService
      .openCustomModal(data, {
        backdropClose: false,
      })
      .pipe(take(1));
  }

  close(res: any) {
    this.modalService.close(res);
  }
}
